import { render, staticRenderFns } from "./consultingprofile.vue?vue&type=template&id=b79a442a&"
import script from "./consultingprofile.vue?vue&type=script&lang=js&"
export * from "./consultingprofile.vue?vue&type=script&lang=js&"
import style0 from "./consultingprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports